<template>
  <me-combo-tree v-bind="$props" v-on="$listeners" :data="comboData" />
</template>
<script>

import http from '@common/ExtendHttp'
import comboMixin from '../mixins/combo.mixin'
export default {
  mixins: [ comboMixin ],
  name: 'ComboTreeMenu',
  props: {
    pathName: {
      type: String, default: '/authority/menu/tree'
    },
    systemCode: { type: String, default: 'PORTAL' }
  },
  data () {
    return {
      comboData: [],
      eventName: 'refresh--comno-tree-menu'
    }
  },
  created () {
    this.$eventMonitor.register(this.eventName, data => {
      http.get(this.pathName, { systemCode: this.systemCode }).then(data => {
        this.comboData = data
      })
    })
    this.$eventMonitor.dispatch(this.eventName)
  },
  watch: {
    systemCode (value) {
      console.debug('ComboTreeMenu -------> watch ---- systemCode=' + value)
      this.$eventMonitor.dispatch(this.eventName)
    }
  }
}
</script>
